import { Edit, ForkLeft, KeyboardArrowLeft, KeyboardArrowRight, Save } from "@mui/icons-material";
import { Autocomplete, Box, Button, Divider, FormControl, IconButton, InputAdornment, MenuItem, Select, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { FaEye, FaEyeSlash, FaFilter } from "react-icons/fa";
import { GrPowerReset } from "react-icons/gr";
import { IoClose } from "react-icons/io5";
import Popup from "reactjs-popup";
import LastPageIcon from '@mui/icons-material/LastPage';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import DeleteIcon from '@mui/icons-material/Delete';
import { userServicer } from "../../../Commen_Services/user.services";
import customToast from "../../Toast/CustomToast";
interface propsHead {
  openClose: any;
}
interface ResetPasswordForm {
  oldPassword: string;
  Password: string;
  confirmPassword: string;
}

const ResetPassword = ({ open, onClose }: any) => {
  const [form, setForm] = useState<ResetPasswordForm>({
    oldPassword: "",
    Password: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState<Partial<ResetPasswordForm>>({});
  const [loading, setLoading] = useState(false);

  const [showPassword, setShowPassword] = useState({
    old: false,
    new: false,
    confirm: false,
  });

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    let err: Partial<ResetPasswordForm> = {};

    if (!form.oldPassword) err.oldPassword = "Old password required";

    if (!form.Password) err.Password = "New password required";
    else if (form.Password.length < 6)
      err.Password = "Min 6 characters required";

    if (!form.confirmPassword)
      err.confirmPassword = "Confirm password required";
    else if (form.Password !== form.confirmPassword)
      err.confirmPassword = "Passwords do not match";

    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const handleSubmit = () => {
    if (!validate()) return;

    setLoading(true);
    userServicer.resetPassword(form).then(user => {
      if (user.statusCode == 200) {
        if (user.status === false) {
          console.log(user.data);
          customToast.Warning(user.message);

        }
        else {
          customToast.success(user.message);
          onClose();
        }
        setLoading(false);
      }
    });
  };

  if (!open) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        backdropFilter: "blur(4px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
    >

      <Box
        sx={{
          width: 360,
          bgcolor: "#fff",
          p: 3,
          borderRadius: 3,
          boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
        }}
      >
        <Box sx={{ mb: 2 }}>
          <Typography
            sx={{
              fontSize: "25px",
              fontWeight: 600,
              color: "#243C5C",
              mb: 1,
              textAlign: "center",
            }}
          >
            Reset Password
          </Typography>

          <Divider
            sx={{
              backgroundColor: "#d0d7ff",
            }}
          />
        </Box>
        <TextField
          fullWidth
          variant="standard"
          label="Old Password"
          name="oldPassword"
          type={showPassword.old ? "text" : "password"}
          value={form.oldPassword}
          onChange={handleChange}
          error={!!errors.oldPassword}
          helperText={errors.oldPassword || " "}
          FormHelperTextProps={{
            sx: { minHeight: "5px" },
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter")
              document.getElementsByName("newPassword")[0]?.focus();
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {showPassword.old ? (
                  <FaEyeSlash
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      setShowPassword((p) => ({ ...p, old: false }))
                    }
                  />
                ) : (
                  <FaEye
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      setShowPassword((p) => ({ ...p, old: true }))
                    }
                  />
                )}
              </InputAdornment>
            ),
          }}
          sx={{ mb: 2 }}
        />

        <TextField
          fullWidth
          variant="standard"
          label="New Password"
          name="Password"
          type={showPassword.new ? "text" : "password"}
          value={form.Password}
          onChange={handleChange}
          error={!!errors.Password}
          helperText={errors.Password || " "}
          FormHelperTextProps={{
            sx: { minHeight: "5px" },
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter")
              document.getElementsByName("confirmPassword")[0]?.focus();
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {showPassword.new ? (
                  <FaEyeSlash
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      setShowPassword((p) => ({ ...p, new: false }))
                    }
                  />
                ) : (
                  <FaEye
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      setShowPassword((p) => ({ ...p, new: true }))
                    }
                  />
                )}
              </InputAdornment>
            ),
          }}
          sx={{ mb: 2 }}
        />

        <TextField
          fullWidth
          variant="standard"
          label="Confirm Password"
          name="confirmPassword"
          type={showPassword.confirm ? "text" : "password"}
          value={form.confirmPassword}
          onChange={handleChange}
          error={!!errors.confirmPassword}
          helperText={errors.confirmPassword || " "}
          FormHelperTextProps={{
            sx: { minHeight: "5px" },
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleSubmit();
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {showPassword.confirm ? (
                  <FaEyeSlash
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      setShowPassword((p) => ({
                        ...p,
                        confirm: false,
                      }))
                    }
                  />
                ) : (
                  <FaEye
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      setShowPassword((p) => ({
                        ...p,
                        confirm: true,
                      }))
                    }
                  />
                )}
              </InputAdornment>
            ),
          }}
          sx={{ mb: 4 }}
        />

        <Box sx={{ display: "flex", gap: 2 }}>
          <Button
            fullWidth
            variant="contained"
            onClick={handleSubmit}
            disabled={loading}
            sx={{
              backgroundColor: "#243C5C",
              "&:hover": {
                backgroundColor: "#1b2e47",
              },
            }}
          >
            {loading ? "Updating..." : "Submit"}
          </Button>

          <Button fullWidth variant="outlined" onClick={onClose}
            sx={{
              borderColor: "#243C5C",
              color: "#243C5C"

            }}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ResetPassword;